<template>
  <div id="attendees">
    <ul>
      <li><a href="#">Adrienne Newton</a></li>
      <li><a href="#">Alberto Lynch</a></li>
      <li><a href="#">Alexander Cannon</a></li>
      <li><a href="#">Alexandra Harper</a></li>
      <li><a href="#">Alfonso Tate</a></li>
      <li><a href="#">Alfred Carlson</a></li>
      <li><a href="#">Alice Pierce</a></li>
      <li><a href="#">Alicia Barker</a></li>
      <li><a href="#">Allen Wilson</a></li>
      <li><a href="#">Alton Gardner</a></li>
      <li><a href="#">Alyssa Lloyd</a></li>
      <li><a href="#">Amy Lawson</a></li>
      <li><a href="#">Ana Collins</a></li>
      <li><a href="#">Ana Marsh</a></li>
      <li><a href="#">Andre Barrett</a></li>
      <li><a href="#">Andres Griffith</a></li>
      <li><a href="#">Anita Shelton</a></li>
      <li><a href="#">Anne Gibson</a></li>
      <li><a href="#">Annie Cobb</a></li>
      <li><a href="#">Annie Woods</a></li>
      <li><a href="#">Arnold Sparks</a></li>
      <li><a href="#">Arthur Cobb</a></li>
      <li><a href="#">Aubrey Cross</a></li>
      <li><a href="#">Aubrey Schwartz</a></li>
      <li><a href="#">Becky Roberts</a></li>
      <li><a href="#">Benny Briggs</a></li>
      <li><a href="#">Bernard Wallace</a></li>
      <li><a href="#">Bessie Payne</a></li>
      <li><a href="#">Beth Myers</a></li>
      <li><a href="#">Betsy Griffith</a></li>
      <li><a href="#">Billy Conner</a></li>
      <li><a href="#">Blanche Bridges</a></li>
      <li><a href="#">Boyd Anderson</a></li>
      <li><a href="#">Brandon Thornton</a></li>
      <li><a href="#">Brett Padilla</a></li>
      <li><a href="#">Brooke Ramsey</a></li>
      <li><a href="#">Bryant Wallace</a></li>
      <li><a href="#">Candice Mendoza</a></li>
      <li><a href="#">Carlos Collier</a></li>
      <li><a href="#">Carole Daniels</a></li>
      <li><a href="#">Carrie Mann</a></li>
      <li><a href="#">Cary Alvarez</a></li>
      <li><a href="#">Cedric Boyd</a></li>
      <li><a href="#">Cedric Franklin</a></li>
      <li><a href="#">Charlene Stone</a></li>
      <li><a href="#">Chelsea Miles</a></li>
      <li><a href="#">Cheryl Becker</a></li>
      <li><a href="#">Christie Bush</a></li>
      <li><a href="#">Clara Lambert</a></li>
      <li><a href="#">Clint Mclaughlin</a></li>
      <li><a href="#">Cody Barnett</a></li>
      <li><a href="#">Colleen Coleman</a></li>
      <li><a href="#">Connie Phelps</a></li>
      <li><a href="#">Curtis Wong</a></li>
      <li><a href="#">Dale Simmons</a></li>
      <li><a href="#">Dale Woods</a></li>
      <li><a href="#">Damon Graves</a></li>
      <li><a href="#">Dan Fletcher</a></li>
      <li><a href="#">Dana Barker</a></li>
      <li><a href="#">Darlene Hunter</a></li>
      <li><a href="#">Darrell Sutton</a></li>
      <li><a href="#">Darren Martinez</a></li>
      <li><a href="#">Darrin Pittman</a></li>
      <li><a href="#">Dawn Simon</a></li>
      <li><a href="#">Deanna Walker</a></li>
      <li><a href="#">Debbie Harrington</a></li>
      <li><a href="#">Delbert Copeland</a></li>
      <li><a href="#">Delbert Perry</a></li>
      <li><a href="#">Della Salazar</a></li>
      <li><a href="#">Derrick Larson</a></li>
      <li><a href="#">Desiree Ortiz</a></li>
      <li><a href="#">Devin Butler</a></li>
      <li><a href="#">Dexter Mason</a></li>
      <li><a href="#">Dianna Burton</a></li>
      <li><a href="#">Doris Pope</a></li>
      <li><a href="#">Drew Morrison</a></li>
      <li><a href="#">Dwight Fields</a></li>
      <li><a href="#">Edmund Bass</a></li>
      <li><a href="#">Edward Henry</a></li>
      <li><a href="#">Eleanor Daniel</a></li>
      <li><a href="#">Elena Morgan</a></li>
      <li><a href="#">Elizabeth Nichols</a></li>
      <li><a href="#">Elsa Ramos</a></li>
      <li><a href="#">Elsie Barrett</a></li>
      <li><a href="#">Erica Nelson</a></li>
      <li><a href="#">Erika Howell</a></li>
      <li><a href="#">Erika Walters</a></li>
      <li><a href="#">Ervin Frank</a></li>
      <li><a href="#">Estelle Nunez</a></li>
      <li><a href="#">Estelle Walsh</a></li>
      <li><a href="#">Eunice Gardner</a></li>
      <li><a href="#">Felipe Higgins</a></li>
      <li><a href="#">Felix Santiago</a></li>
      <li><a href="#">Florence Rogers</a></li>
      <li><a href="#">Frances Watkins</a></li>
      <li><a href="#">Francisco Sutton</a></li>
      <li><a href="#">Garrett Hayes</a></li>
      <li><a href="#">Gene Christensen</a></li>
      <li><a href="#">Geoffrey Christensen</a></li>
      <li><a href="#">Glen Davis</a></li>
      <li><a href="#">Glen Holt</a></li>
      <li><a href="#">Gloria Riley</a></li>
      <li><a href="#">Guillermo Jennings</a></li>
      <li><a href="#">Guy Reeves</a></li>
      <li><a href="#">Harriet Quinn</a></li>
      <li><a href="#">Harriet Weber</a></li>
      <li><a href="#">Hazel Barnes</a></li>
      <li><a href="#">Hector Gibbs</a></li>
      <li><a href="#">Heidi Marsh</a></li>
      <li><a href="#">Herman Franklin</a></li>
      <li><a href="#">Herman Holmes</a></li>
      <li><a href="#">Hubert Ferguson</a></li>
      <li><a href="#">Hugo Padilla</a></li>
      <li><a href="#">Ian Garza</a></li>
      <li><a href="#">Irene Ryan</a></li>
      <li><a href="#">Iris Armstrong</a></li>
      <li><a href="#">Irvin Jordan</a></li>
      <li><a href="#">Irvin King</a></li>
      <li><a href="#">Ivan Graham</a></li>
      <li><a href="#">Jackie Peterson</a></li>
      <li><a href="#">Jacqueline Roberts</a></li>
      <li><a href="#">Jake Conner</a></li>
      <li><a href="#">Jake Hall</a></li>
      <li><a href="#">Jana Moran</a></li>
      <li><a href="#">Jane Roy</a></li>
      <li><a href="#">Janet Peterson</a></li>
      <li><a href="#">Janice Ortiz</a></li>
      <li><a href="#">Jeannette Johnson</a></li>
      <li><a href="#">Jeffery Lawson</a></li>
      <li><a href="#">Jennifer Bowman</a></li>
      <li><a href="#">Jerald Rivera</a></li>
      <li><a href="#">Jeremiah White</a></li>
      <li><a href="#">Jerry Carlson</a></li>
      <li><a href="#">Jesse Flores</a></li>
      <li><a href="#">Jessica Rhodes</a></li>
      <li><a href="#">Jesus Miles</a></li>
      <li><a href="#">Jimmie Mcgee</a></li>
      <li><a href="#">Joan Snyder</a></li>
      <li><a href="#">Joe Hudson</a></li>
      <li><a href="#">Joe Kennedy</a></li>
      <li><a href="#">Jordan Yates</a></li>
      <li><a href="#">Josh Gibbs</a></li>
      <li><a href="#">Joy Ramirez</a></li>
      <li><a href="#">Juan Jones</a></li>
      <li><a href="#">Juana Massey</a></li>
      <li><a href="#">Juanita Glover</a></li>
      <li><a href="#">Judith Porter</a></li>
      <li><a href="#">Julian Cannon</a></li>
      <li><a href="#">Julian Newman</a></li>
      <li><a href="#">Julius Oliver</a></li>
      <li><a href="#">Karen Harrison</a></li>
      <li><a href="#">Karl Santos</a></li>
      <li><a href="#">Katherine Aguilar</a></li>
      <li><a href="#">Kendra Little</a></li>
      <li><a href="#">Kevin Holmes</a></li>
      <li><a href="#">Kim Ford</a></li>
      <li><a href="#">Kimberly Hubbard</a></li>
      <li><a href="#">Kimberly Morton</a></li>
      <li><a href="#">Kristin Stephens</a></li>
      <li><a href="#">Kristina Gordon</a></li>
      <li><a href="#">Kyle Warner</a></li>
      <li><a href="#">Lamar Roberson</a></li>
      <li><a href="#">Lamar Watson</a></li>
      <li><a href="#">Laura Brewer</a></li>
      <li><a href="#">Laura Grant</a></li>
      <li><a href="#">Laura Mitchell</a></li>
      <li><a href="#">Laverne Graham</a></li>
      <li><a href="#">Leah Shaw</a></li>
      <li><a href="#">Lela Benson</a></li>
      <li><a href="#">Leo Gonzalez</a></li>
      <li><a href="#">Leon Keller</a></li>
      <li><a href="#">Leonard Moreno</a></li>
      <li><a href="#">Lillian Hayes</a></li>
      <li><a href="#">Lonnie Griffin</a></li>
      <li><a href="#">Loren Moore</a></li>
      <li><a href="#">Loretta Walters</a></li>
      <li><a href="#">Lori Sandoval</a></li>
      <li><a href="#">Lorraine Craig</a></li>
      <li><a href="#">Lucille Flowers</a></li>
      <li><a href="#">Lula Obrien</a></li>
      <li><a href="#">Lydia Warren</a></li>
      <li><a href="#">Lyle Bates</a></li>
      <li><a href="#">Mable Burns</a></li>
      <li><a href="#">Mable Singleton</a></li>
      <li><a href="#">Madeline Rodriguez</a></li>
      <li><a href="#">Maggie Dawson</a></li>
      <li><a href="#">Mandy Greer</a></li>
      <li><a href="#">Manuel Gutierrez</a></li>
      <li><a href="#">Marc Brock</a></li>
      <li><a href="#">Marcella Morris</a></li>
      <li><a href="#">Margarita Simpson</a></li>
      <li><a href="#">Marguerite Luna</a></li>
      <li><a href="#">Maria Mendez</a></li>
      <li><a href="#">Maria Reed</a></li>
      <li><a href="#">Marion Cummings</a></li>
      <li><a href="#">Marion Marsh</a></li>
      <li><a href="#">Marjorie Casey</a></li>
      <li><a href="#">Marlon Young</a></li>
      <li><a href="#">Marta Garner</a></li>
      <li><a href="#">Marta Wolfe</a></li>
      <li><a href="#">Martha Jordan</a></li>
      <li><a href="#">Marty Evans</a></li>
      <li><a href="#">Marvin Mccoy</a></li>
      <li><a href="#">Mathew Jensen</a></li>
      <li><a href="#">May Jacobs</a></li>
      <li><a href="#">May Mckenzie</a></li>
      <li><a href="#">Michael Bush</a></li>
      <li><a href="#">Miguel Rodriguez</a></li>
      <li><a href="#">Mike Cook</a></li>
      <li><a href="#">Mona Bennett</a></li>
      <li><a href="#">Monica Wise</a></li>
      <li><a href="#">Monique Cross</a></li>
      <li><a href="#">Myron Barber</a></li>
      <li><a href="#">Naomi Harrison</a></li>
      <li><a href="#">Natalie Davidson</a></li>
      <li><a href="#">Nellie Barnett</a></li>
      <li><a href="#">Nicolas Gonzales</a></li>
      <li><a href="#">Nicole Ortega</a></li>
      <li><a href="#">Nina Bishop</a></li>
      <li><a href="#">Nora Brooks</a></li>
      <li><a href="#">Ollie Hicks</a></li>
      <li><a href="#">Ollie Thomas</a></li>
      <li><a href="#">Orville Davidson</a></li>
      <li><a href="#">Pamela Hogan</a></li>
      <li><a href="#">Pat Myers</a></li>
      <li><a href="#">Patricia Horton</a></li>
      <li><a href="#">Patrick Daniels</a></li>
      <li><a href="#">Patty Shaw</a></li>
      <li><a href="#">Paula Washington</a></li>
      <li><a href="#">Pauline Cole</a></li>
      <li><a href="#">Pearl Leonard</a></li>
      <li><a href="#">Pete Tate</a></li>
      <li><a href="#">Ramon Bryant</a></li>
      <li><a href="#">Regina Lloyd</a></li>
      <li><a href="#">Reginald Chavez</a></li>
      <li><a href="#">Ricardo Newton</a></li>
      <li><a href="#">Richard Cunningham</a></li>
      <li><a href="#">Rick Hill</a></li>
      <li><a href="#">Robert Stevenson</a></li>
      <li><a href="#">Rodolfo Cobb</a></li>
      <li><a href="#">Roosevelt Harmon</a></li>
      <li><a href="#">Rosemarie Mendoza</a></li>
      <li><a href="#">Rosie Ellis</a></li>
      <li><a href="#">Ross Cooper</a></li>
      <li><a href="#">Roy Davis</a></li>
      <li><a href="#">Salvador Horton</a></li>
      <li><a href="#">Sam Moody</a></li>
      <li><a href="#">Sammy Garza</a></li>
      <li><a href="#">Samuel Hart</a></li>
      <li><a href="#">Saul Garner</a></li>
      <li><a href="#">Sean Scott</a></li>
      <li><a href="#">Sergio Dixon</a></li>
      <li><a href="#">Shannon Carson</a></li>
      <li><a href="#">Shari Manning</a></li>
      <li><a href="#">Sharon Bass</a></li>
      <li><a href="#">Shelley Boone</a></li>
      <li><a href="#">Sherman Roberts</a></li>
      <li><a href="#">Sherri Boone</a></li>
      <li><a href="#">Sherry Harmon</a></li>
      <li><a href="#">Spencer Castillo</a></li>
      <li><a href="#">Stacy Jensen</a></li>
      <li><a href="#">Stephanie Ross</a></li>
      <li><a href="#">Susan Lopez</a></li>
      <li><a href="#">Susan Romero</a></li>
      <li><a href="#">Susie Ingram</a></li>
      <li><a href="#">Susie Schwartz</a></li>
      <li><a href="#">Sylvester Schultz</a></li>
      <li><a href="#">Sylvester Underwood</a></li>
      <li><a href="#">Sylvia Osborne</a></li>
      <li><a href="#">Tanya Collier</a></li>
      <li><a href="#">Tara Brady</a></li>
      <li><a href="#">Ted Guerrero</a></li>
      <li><a href="#">Terence Burgess</a></li>
      <li><a href="#">Terence Morrison</a></li>
      <li><a href="#">Terrence Flores</a></li>
      <li><a href="#">Terrence Jenkins</a></li>
      <li><a href="#">Terry Neal</a></li>
      <li><a href="#">Thomas Klein</a></li>
      <li><a href="#">Tiffany Gregory</a></li>
      <li><a href="#">Tim Ballard</a></li>
      <li><a href="#">Toby Brady</a></li>
      <li><a href="#">Tommy Caldwell</a></li>
      <li><a href="#">Toni Curtis</a></li>
      <li><a href="#">Tracey Ramos</a></li>
      <li><a href="#">Traci Erickson</a></li>
      <li><a href="#">Tracy Freeman</a></li>
      <li><a href="#">Tracy Lamb</a></li>
      <li><a href="#">Travis Murray</a></li>
      <li><a href="#">Viola Foster</a></li>
      <li><a href="#">Violet Vargas</a></li>
      <li><a href="#">Wade Moreno</a></li>
      <li><a href="#">Wanda Marshall</a></li>
      <li><a href="#">Warren Dean</a></li>
      <li><a href="#">Wendell Mcbride</a></li>
      <li><a href="#">Wendy Bennett</a></li>
      <li><a href="#">Wesley Abbott</a></li>
      <li><a href="#">Wilbert Greer</a></li>
      <li><a href="#">Willie Jennings</a></li>
      <li><a href="#">Woodrow Hanson</a></li>
      <li><a href="#">Yvette Payne</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "p-attendees"
};
</script>

<style lang="scss" scoped>
#attendees {
  ul {
    columns: 2;
    list-style: none;
    padding: 0;
    width: 100%;

    li {
      width: max-content;
    }
  }
}
</style>
